import React from "react";
import {Wrapper} from "./Underline.styles"

const Underline = () => {
    return (
      <Wrapper></Wrapper>
    );
  };
  
  export default Underline;
  